import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_Tab = _resolveComponent("Tab")
  const _component_TabList = _resolveComponent("TabList")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabPanels = _resolveComponent("TabPanels")
  const _component_Tabs = _resolveComponent("Tabs")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_Tabs, {
      value: _ctx.tabs,
      "show-navigators": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabList, null, {
          default: _withCtx(() => [
            _createVNode(_component_Tab, {
              value: "movie",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.tabs = 'movie')),
              pt: { root: 'text-xs !px-3 !py-2.5' }
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("หนัง")
              ])),
              _: 1 /* STABLE */,
              __: [3]
            }),
            _createVNode(_component_Tab, {
              value: "anime",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.tabs = 'anime')),
              pt: { root: 'text-xs !px-3 !py-2.5' }
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("อนิเมะ")
              ])),
              _: 1 /* STABLE */,
              __: [4]
            }),
            _createVNode(_component_Tab, {
              value: "av",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.tabs = 'av')),
              pt: { root: 'text-xs !px-3 !py-2.5' }
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("เอวีซับไทย")
              ])),
              _: 1 /* STABLE */,
              __: [5]
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_TabPanels, { pt: { root: 'px-0!' } }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, { value: _ctx.tabs }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabComponentMap[_ctx.tabs]), { key: _ctx.tabs }))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["value"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["value"])
  ]))
}